import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { CartLines, OrderTotals } from "@/components/Commerce";
import "@/commerce.css";
export default function OrderResult({ cancelled=false }) {
  const { previewOrder } = useCart();
  return <main className="commerce-page"><h1>{cancelled ? "Checkout cancelled" : previewOrder ? "Your saved selection" : "No saved selection to display"}</h1>
    <p>{cancelled ? "No payment was taken. Your cart has been kept so you can continue when you’re ready." : "Your selection is saved for this visit. Contact help@lenisnutrition.co.uk to confirm availability and arrange your purchase."}</p>
    {!cancelled && previewOrder && <section className="commerce-panel"><h2>Purchase summary</h2><p>{previewOrder.purchaseType === "subscribe" ? "Monthly delivery preference" : "One-time purchase"}</p><CartLines order={previewOrder}/><OrderTotals order={previewOrder}/></section>}
    <Link className="commerce-button" to={cancelled?"/checkout":"/?section=products"}>{cancelled?"Return to checkout":"Continue shopping"}</Link>
    <Link className="commerce-secondary" to="/cart">View cart</Link>
  </main>;
}


